import {
	RefundFieldsFragment,
	OrderCreditCardPaymentFieldsFragment,
	OrderGiftCardPaymentFieldsFragment
} from '../../../graphql';

const isGiftCard = (
	payment:
		| OrderGiftCardPaymentFieldsFragment
		| OrderCreditCardPaymentFieldsFragment
): payment is OrderGiftCardPaymentFieldsFragment => {
	return (
		(payment as OrderGiftCardPaymentFieldsFragment).cardNumber !== undefined
	);
};

export const getRefundPayments = (
	refund: RefundFieldsFragment
): [
	OrderGiftCardPaymentFieldsFragment[],
	OrderCreditCardPaymentFieldsFragment[]
] => {
	const giftCardPayments: OrderGiftCardPaymentFieldsFragment[] = [];
	const creditCardPayments: OrderCreditCardPaymentFieldsFragment[] = [];

	for (let i = 0; i < refund.destinations.length; i++) {
		const payment = refund.destinations[i].payment;
		if (isGiftCard(payment)) {
			giftCardPayments.push(payment);
		} else {
			creditCardPayments.push(payment);
		}
	}

	return [giftCardPayments, creditCardPayments];
};
